import React from "react";
const Phone = ({ size = 24, color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15.999 16.067"
  >
    <path
      fill="none"
      stroke={color}
      d="M12.972 36.388a1.573 1.573 0 0 0-1.141-.523 1.626 1.626 0 0 0-1.154.52L9.61 37.447c-.088-.047-.176-.091-.26-.135-.122-.061-.236-.118-.334-.179A11.592 11.592 0 0 1 6.238 34.6a6.839 6.839 0 0 1-.911-1.438c.277-.253.533-.516.783-.77l.284-.287a1.549 1.549 0 0 0 0-2.336l-.921-.921c-.1-.1-.213-.213-.314-.321-.2-.209-.415-.425-.635-.628a1.6 1.6 0 0 0-1.131-.5 1.653 1.653 0 0 0-1.148.5l-.007.007-1.147 1.161a2.469 2.469 0 0 0-.732 1.569 5.917 5.917 0 0 0 .432 2.5 14.533 14.533 0 0 0 2.582 4.307 15.884 15.884 0 0 0 5.289 4.141 8.241 8.241 0 0 0 2.97.878c.071 0 .145.007.213.007a2.543 2.543 0 0 0 1.948-.837c0-.007.01-.01.014-.017a7.675 7.675 0 0 1 .591-.611c.145-.138.294-.284.439-.435a1.684 1.684 0 0 0 .51-1.168 1.622 1.622 0 0 0-.52-1.158z"
      transform="translate(.155 -26.906)"
    />
  </svg>
);
export default Phone;
